'use client';

import { type SliceCreator, type EditorStore, type EditorMetaSlice } from './type';

export const createEditorMetaSlice: SliceCreator<EditorMetaSlice, EditorStore> = () => ({
    isMobile: false,
    isLoading: true,
    isSaving: false,
    headerHeight: 0,
    footerHeight: 0,
});
